import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiNoticeService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.notice.form.component.html"
    ,providers: []
})
export class DtgManageNoticeFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() noticeInfo:any;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    listNotice:any;
    currentUserInfo:any;
    userGroupId:number = 99999;
    listNoticeType:any[] = ["INFO","UPDATE","ERROR","ETC"];
    listNoticeTarget:any[] = ["ALL","LOGIN"];
    
    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        if(this.currentUserInfo){
            this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        }
     }

    ngOnInit() {
        this.initForm();
        if(this.noticeInfo){
            if(this.noticeInfo.popupDtFrom){
                this.noticeInfo.popupDtFrom = this.noticeInfo.popupDtFrom.replace(/\s/g,"T");
            }
            if(this.noticeInfo.popupDtTo){
                this.noticeInfo.popupDtTo = this.noticeInfo.popupDtTo.replace(/\s/g,"T");
            }
        }
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.formGroup.patchValue(this.noticeInfo);
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.formGroup.patchValue(this.noticeInfo);
                this.formGroup.disable();
                break;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            noticeId:[
                ""
            ]
            ,title:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,content:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,viewCnt:0
            ,noticeType:[
                "ETC"
                ,[
                    Validators.required
                    //공지구분(INFO, UPDATE, ERROR, ETC)
                ]
            ]
            ,noticeTarget:"ALL" //공지대상(ALL, LOGIN)
            ,noticeCompanyId:0 //공지대상회사id (지정회사만 공지하고 싶을때)
            ,popupYn:"N" //팝업으로 띄울건지
            ,popupDtFrom:null //팝업을 띄운다면 언제부터
            ,popupDtTo:null //팝업을 띄운다면 언제까지
            ,createDt:null
            ,createUser:this.currentUserInfo.userId
            ,updateDt:null
            ,updateUser:this.currentUserInfo.userId
        });
    }

    get f() { return this.formGroup.controls; }

    parseContent(content){
        return decodeURIComponent(content);
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        // this.submitted = true;
        console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let noticeItem = {
            noticeId:this.f.noticeId.value
            ,title:this.f.title.value
            ,content:this.f.content.value
            ,viewCnt:this.f.viewCnt.value
            ,noticeType:this.f.noticeType.value
            ,noticeTarget:this.f.noticeTarget.value
            ,noticeCompanyId:this.f.noticeCompanyId.value
            ,popupYn:this.f.popupYn.value
            ,popupDtFrom:this.f.popupDtFrom.value
            ,popupDtTo:this.f.popupDtTo.value
            ,createDt:this.f.createDt.value
            ,updateDt:this.f.updateDt.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
        };
        if(this.f.popupDtFrom.value){
            noticeItem.popupDtFrom = this.f.popupDtFrom.value.replace(/T/g," ");
        }
        if(this.f.popupDtTo.value){
            noticeItem.popupDtTo = this.f.popupDtTo.value.replace(/T/g," ");
        }
        this.fvmsApiNoticeService.upsertNotice(noticeItem)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    console.log("ok",apiResponse.resultValue);
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}